import styled from 'styled-components';
import { FC } from 'react';
import { Card as AntCard } from 'antd';

import { CardGridProps, CardProps } from './types';

export const Card = styled<FC<CardProps>>(AntCard)``;

export const CardGrid = styled<FC<CardGridProps>>(AntCard.Grid)``;
